import React, { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import Welcome from "./welcome";
import NextAppointmentWidget from "./next-appointment-widget";
import DoctorProfile from "./doctor-profile";
import DoctorActivities from "./doctor-activities";
import SideDrawer from "../InstantConsultation/SideDrawer/SideDrawer_v2";
import CompleteProfileBanner from "../WebinarNew/complete-profile-banner";
import UpcomingVacationWidget from "./upcoming-vacation-widget";
import HomeIcon from "@material-ui/icons/Home";
import guideIcon from "../../assets/guide_icon.png";

import "./component-styles.scss";
import useWindowSize from "../../Hooks/useWindowSize";

import AnnouncementBarForAll from "../AnnouncementBar/AnnouncementBarForAll";
import UpcomingWebinarsNew from "./upcoming-webinars-new";

import StarRatingTicker from "../UI Component/StarRating/StarRatingTicker";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";

import StarRating from "../UI Component/StarRating/StarRating";
import MessageBox from "../UI Component/StarRating/MessageBox";
import { isMobile } from "react-device-detect";
import DashboardAppointmentsView from "../DashboardAppointmentsView";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

function DoctorDashboardNew(props) {
  const size = useWindowSize();
  // Doctor Profile State
  const [profile, setProfile] = useState({
    prefix_name: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    specialization: "",
    short_url_slug: "",
    is_partial_doctor: "false",
    doctor_onboard_link: "",
    onboarding_form_completed: "",
  });
  const [cookies] = useCookies(["cookie-name"]);
  const [doctorFullName, setDoctorFullName] = useState("");
  const [showInstantConsult, setShowInstantConsult] = useState(false);
  const viewNow = localStorage.getItem("viewNow") ? false : true;
  //guided tour status
  const [showJoyride, setShowJoyride] = useState(false);

  // Next Appointment State
  const [nextAppointment, setNextAppointment] = useState({
    patient_name: "",
    id: "", // appointment id
    appointment_id: "",
    appointment_date: "",
    start_time: "",
    end_time: "",
    // below properties are required for video consultation page
    patient_dob: "",
    appointment_end_date_time: "",
    first_name: "",
    last_name: "",
    degree: "",
    phone_no: "",
    patient_city: "",
  });

  // AnnouncementBarForDoctor view
  const [showAnnouncementBar, setShowAnnouncementBar] = useState(false);
  const [checkLastConsultationFeedback, setCheckLastConsultationFeedback] =
    useState("");
  const [feedbackProvided, setFeedbackProvided] = useState(true);
  const [feedbackStatus, setFeedbackStatus] = useState(false);
  const [tickerAnimate, setTickerAnimate] = useState(true);
  const [feedbackAppoinmentId, setFeedbackAppoinmentId] = useState(null);
  const [feedbackSuccessStatus, setFeedbackSuccessStatus] = useState(false);
  const [newRating, setNewRating] = useState(null);
  const [providerType, setProviderType] = useState(1);
  const [isUpcomingVacation, setIsUpcomingVacation] = useState(false);
  const [renderNextAppointmentApi, setRenderNextAppointmentApi] =
    useState(false);

  let is_staff = localStorage.getItem("user_type");
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let openStarRatingPopups = localStorage.getItem("openStarRatingPopups");

  // Set Doctor Full Name
  useEffect(() => {
    let fullName =
      (profile?.prefix_name
        ? profile?.prefix_name?.indexOf(".") > -1
          ? profile?.prefix_name
          : `${profile?.prefix_name}.`
        : "") +
      (profile?.first_name ? " " + profile?.first_name : "") +
      (profile?.middle_name ? " " + profile?.middle_name : "") +
      (profile?.last_name ? " " + profile?.last_name : "");
    setDoctorFullName(fullName);
  }, [profile]);

  // get privious rating status
  useEffect(() => fetchPreviousRatingStatus(), []);

  function fetchPreviousRatingStatus() {
    afterLoginApiAxios
      .post(
        "/doctor/check-last-consultation-feedback",
        { user_id: userId ? userId : cookies?.user_id },
        // { upcoming: true },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token")
              ? localStorage.getItem("id_token")
              : cookies?.id_token,
          },
        }
      )
      .then((response) => {
        if (response.data.statusCode === 200) {
          setCheckLastConsultationFeedback(response.data.data);
          if (openStarRatingPopups) {
            setFeedbackProvided(true);
            setFeedbackStatus(true);
            setFeedbackAppoinmentId(
              localStorage.getItem("qualaroo_appointment_id")
            );
          } else {
            setFeedbackProvided(response.data.feedback_provided);
          }
        }
      })
      .catch((err) => {
        C2CConsole.log(err);
      });
  }

  // Callback to get doctor profile data
  function profileCallback(p) {
    setProfile(p);
  }

  // Callback to get next appointment
  function getNextAppointment(next) {
    setRenderNextAppointmentApi(false);
    if (next) {
      setNextAppointment(next);
    }
  }

  function handleInstantConsultDrawerClose() {
    setShowInstantConsult(false);
  }

  const joyrideToggle = () => setShowJoyride(!showJoyride);

  function showAnnouncementBarAnnounce(show) {
    setShowAnnouncementBar(show);
  }

  const ratingChanged = (newRating) => {
    setNewRating(newRating);
    callStarRating();
  };

  const callStarRating = () => {
    setProviderType(1);
    setFeedbackStatus(true);
    setTickerAnimate(false);
    setFeedbackAppoinmentId(checkLastConsultationFeedback.appointment_id);
  };

  const closeTicker = () => {
    setTickerAnimate(false);
  };

  const onCancelFeedback = () => {
    setFeedbackStatus(false);
    setFeedbackAppoinmentId(null);
    setFeedbackSuccessStatus(false);
    if (
      window?.location?.pathname &&
      window?.location?.pathname?.includes("clinic")
    ) {
      window.location.href = "/clinic/account/dashboard";
    } else {
      window.location.href = "/doctor/account/dashboard";
    }
    localStorage.removeItem("qualaroo_appointment_id");
    localStorage.removeItem("openStarRatingPopups");
  };

  const onSuccessFeedback = (
    starRating,
    starRatingAudio,
    starRatingVideo,
    starRatingRx,
    starRatingConsultation,
    starRatingEaseOfBooking,
    feedback
  ) => {
    if (starRating) {
      afterLoginApiAxios
        .post(
          "/user/add-rating-feedback",
          {
            provider_id: userId,
            provider_type: 1,
            rating_point: starRating,
            feedback_message: feedback,
            action_on_item_id: feedbackAppoinmentId,
            appointment_id: checkLastConsultationFeedback.appointment_id,
            action_on_item_type: "consultation",
            source: isMobile ? "mobile view" : "desktop",
            audio_quality: starRatingAudio,
            video_quality: starRatingVideo,
            rx_generation: starRatingRx,
            consultation_joining: starRatingConsultation,
            booking_payment: starRatingEaseOfBooking,
          },
          {
            headers: {
              Authorization: localStorage.getItem("id_token"),
            },
          }
        )
        .then((res) => {
          if (res.data && res.data.statusCode && res.data.statusCode === 200) {
            localStorage.removeItem("openStarRatingPopups");
            setFeedbackStatus(false);
            setFeedbackSuccessStatus(true);
          }
        })
        .catch((err) => C2CConsole.error(err));
    }
  };

  const handleUpcomingVacation = (val) => {
    setIsUpcomingVacation(val);
  };
  const callNextAppointmentWidget = () => {
    setRenderNextAppointmentApi(true);
  };

  return (
    <>
      <div className="container-fluid p-0 dashboard-content">
        {profile?.is_partial_doctor &&
        profile?.is_partial_doctor.toLowerCase() !== "false" ? (
          <div className="row m-0">
            <div className="col-12">
              <CompleteProfileBanner
                doctor_onboard_link={profile?.doctor_onboard_link}
                onboarding_form_completed={profile?.onboarding_form_completed}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          style={{
            borderBottom: "1px solid #d6dae5",
            borderTop: "1px solid #d6dae5",
            display: "flex",
            boxShadow: "0 2px 5px 2px rgb(0, 0, 0, 0.1)",
            marginBottom: size.width < 800 ? "20px" : "0",
          }}
        >
          <div
            className="staff-header-container d-flex w-100 justify-content-between"
            style={{ padding: isUpcomingVacation ? "9px 25px" : "" }}
          >
            <div
              className={
                size.width > 800 ? "d-flex align-items-center" : "w-100"
              }
            >
              <Welcome doctorFullName={doctorFullName} />
              {profile?.is_partial_doctor &&
              profile?.is_partial_doctor.toLowerCase() === "false" ? (
                <UpcomingVacationWidget
                  handleUpcomingVacation={handleUpcomingVacation}
                />
              ) : (
                ""
              )}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "-20px",
              }}
            >
              <div
                className="doctor-info-home doctor-info-mob-icon mb-4 mr-2"
                onClick={() => {
                  props.history.push("/");
                }}
              >
                <HomeIcon className="doctor-info-home-icon" />
                Home
              </div>
              <div className="d-none doctor-info-guide doctor-info-mob-icon mb-4">
                {/* added d-none */}
                <span
                  onClick={() => {
                    joyrideToggle();
                  }}
                >
                  <img src={guideIcon} alt="g" />
                  Guide
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row m-0 dashboard-container">
          <div
            className="col-lg-9 col-12 p-0 m-0 dashboard-left-container"
            style={{
              height:
                window.innerWidth > 767 && isUpcomingVacation
                  ? "calc(100vh - 78px)"
                  : "",
            }}
          >
            {viewNow && showAnnouncementBar && (
              <div className="row mt-4">
                <div className="col-12">
                  <AnnouncementBarForAll
                    showAnnouncementBarCallback={showAnnouncementBarAnnounce}
                  />
                </div>
              </div>
            )}
            {window.innerWidth < 798 && (
              <div className="col-sm-12 col-lg-6 col-12 doctor_card_view">
                <NextAppointmentWidget
                  getNextAppointmentCallback={getNextAppointment}
                  is_partial_doctor={profile?.is_partial_doctor}
                  handleRatingPopup={() => {
                    setFeedbackStatus(true);
                  }}
                  handleEndCall={() => {
                    setFeedbackAppoinmentId(
                      localStorage.getItem("qualaroo_appointment_id")
                    );
                    fetchPreviousRatingStatus();
                  }}
                />
              </div>
            )}
            {profile?.is_partial_doctor &&
            profile?.is_partial_doctor.toLowerCase() === "false" ? (
              <div className="row">
                <div className="col-12">
                  <DashboardAppointmentsView
                    callNextAppointmentWidget={callNextAppointmentWidget}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="row mt-3 mt-lg-4">
              <div className="col-12">
                <UpcomingWebinarsNew />
              </div>
            </div>
          </div>

          <div
            className={
              "col-lg-3 col-12 p-0 pb-3 dashboard-right-container " +
              (window.innerWidth < 767 ? "pb-5" : "")
            }
            style={{
              height:
                window.innerWidth > 767 && isUpcomingVacation
                  ? "calc(100vh - 78px)"
                  : "",
            }}
          >
            {window.innerWidth > 798 && (
              <div className="col-sm-12 col-lg-12 col-12 pb-4 mt-4 doctor_card_view w-100">
                <NextAppointmentWidget
                  getNextAppointmentCallback={getNextAppointment}
                  renderNextAppointmentApi={renderNextAppointmentApi}
                  is_partial_doctor={profile?.is_partial_doctor}
                  handleRatingPopup={() => {
                    setFeedbackStatus(true);
                  }}
                  handleEndCall={() => {
                    setFeedbackAppoinmentId(
                      localStorage.getItem("qualaroo_appointment_id")
                    );
                    fetchPreviousRatingStatus();
                  }}
                />
              </div>
            )}
            <div className="p-3">
              <DoctorProfile
                parentCallback={profileCallback}
                nextAppointment={nextAppointment}
                joyrideToggle={joyrideToggle}
                callNextAppointmentWidget={callNextAppointmentWidget}
              />
              {profile?.is_partial_doctor &&
              profile?.is_partial_doctor.toLowerCase() === "false" ? (
                <DoctorActivities
                  slugUrl={profile?.short_url_slug}
                  doctorFullName={doctorFullName}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

      {profile?.is_partial_doctor &&
        profile?.is_partial_doctor.toLowerCase() === "false" &&
        showInstantConsult && (
          <SideDrawer
            className="side_drawer_main"
            open={showInstantConsult}
            slugUrl={profile.short_url_slug}
            doctorName={doctorFullName}
            nextPatientName={nextAppointment.patient_name}
            nextAppointmentDate={nextAppointment.appointment_date}
            nextStartTime={nextAppointment.appointment_start_time}
            nextEndTime={nextAppointment.appointment_end_time}
            nextAppointmentId={nextAppointment.appointment_id}
            closeDrawerCallback={handleInstantConsultDrawerClose}
            history={props.history}
          />
        )}
      <>
        {is_staff === "doctor" ? (
          feedbackProvided ? (
            ""
          ) : (
            <StarRatingTicker
              checkLastConsultationFeedback={checkLastConsultationFeedback}
              callStarRating={callStarRating}
              closeTicker={closeTicker}
              ratingChanged={ratingChanged}
              tickerAnimate={tickerAnimate}
              newRating={newRating}
            />
          )
        ) : (
          ""
        )}
      </>
      <>
        {feedbackStatus ? (
          <StarRating
            successHandler={onSuccessFeedback}
            closeHandler={onCancelFeedback}
            show={feedbackStatus}
            provider_type={providerType}
            newRating={newRating}
          />
        ) : (
          ""
        )}
        {feedbackSuccessStatus ? (
          <MessageBox
            successHandler={onCancelFeedback}
            closeHandler={onCancelFeedback}
            show={feedbackSuccessStatus}
          />
        ) : (
          ""
        )}
      </>
      {/* <DownloadReport /> */}
    </>
  );
}

export default DoctorDashboardNew;
